export default "__VITE_ASSET__ddae1a56__"